import request from '@/utils/http';
// 我的投标列表
export const bidBidList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidBidListQuery`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 我的投标详情
export const supplierDetails = (id) => {
    return request({
        url: `/api-srm-web/bid/supplierDetails/${id}`,
        method: 'get'
    }).then(res => res);
};

// 第三方支付url获取
export const costOrderPay = (params) => {
    return request({
        url: `/api-srm-web/bid/costOrderPay`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 按供应商编号查询盖章人信息
export const getSupplierStamperInfo = (supplierCode) => {
    return request({
        url: `/api-srm-web/supplier/getEnableBySupplierStamperInfo/${supplierCode}`,
        method: 'get'
    }).then(res => res);
};

// 联系人保存, 应标文件生成
export const saveStampData = (params) => {
    return request({
        url: `/api-srm-web/bid/saveStampData/first`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 第二次修改联系人保存, 应标文件生成
export const saveStampDataModule = (params, moduleNo) => {
    return request({
        url: `/api-srm-web/bid/saveStampData/${moduleNo}`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 查看运费
export const getSupplierFreight = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCost/getSupplierFreight`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 费用列表跳转 查看标书费，投标费头部信息接口
export const getSupplierCostByBond = (params) => {
    return request({
        url: `/api-srm-web/bid/getSupplierCostByBond`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 审核 未结运费数据明细
export const getSupplierCostDetails = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCostDetails`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 我的投标列表跳转 查看标书费，投标费头部信息接口
export const bidBid4Cost = (params) => {
    return request({
        url: `/api-srm-web/bid/bidBid4Cost`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 线下汇款保存凭证接口
export const offlineRemittance = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCost/offlineRemittance`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 保存运费转保证金接口
export const freightTransferred = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCost/freightTransferred`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 应标文件盖章
export const bidFileStamp = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplier/bidFileStamp `,
        method: 'post',
        data: params
    }).then(res => res);
};

// 获取盖章联系人和盖章文件列表接口
export const getBidFileStampInfo = (params) => {
    return request({
        url: `/api-srm-web/bid/bidFileStamp/getBidFileStampInfo`,
        method: 'post',
        data: params
    }).then(res => res);
};

export const bidWinning = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplier/bidWinning`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 推送退款申请盖章
export const sendRefundStamp = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplierCost/sendRefundStamp`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 中标价格表盖章撤回
export const bidSealWithdrawal = (params) => {
    return request({
        url: `/api-srm-web/bid/bidFileStamp/bidSealWithdrawal`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 删除应标联系人
export const delBidTenderUser = (id) => {
    return request({
        url: `/api-srm-web/bid/bidTenderUser/${id}`,
        method: 'delete'
    }).then(res => res);
};

// 管理端上传应标文件
export const savebidResponse = (params) => {
    return request({
        url: `/api-srm-web/bid/save/bidResponse`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 管理端上传中标价格表、退款申请函
export const manualUploadFile = (params) => {
    return request({
        url: `/api-srm-web/bid/bidSupplier/manualUploadFile`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 判断展示生成唯一编码按钮
export const existConfig = (params) => {
    return request({
        url: `/api-srm-web/bid/bidUserControls/existConfig`,
        method: 'get',
        params
    });
};
// 生成唯一编码
export const createIdfCode = (params) => {
    return request({
        url: `/api-srm-web/bid/bidUserControls/createIdentificationCode`,
        method: 'get',
        params
    });
};
